const NAME = 'KISSMETRICS';
const CNameMapping = {
  [NAME]: NAME,
  Kissmetrics: NAME,
  kissmetrics: NAME,
};

export { NAME, CNameMapping };
